import { render, staticRenderFns } from "./TaxSummary.vue?vue&type=template&id=472653f7&scoped=true"
import script from "./TaxSummary.vue?vue&type=script&lang=js"
export * from "./TaxSummary.vue?vue&type=script&lang=js"
import style0 from "./TaxSummary.vue?vue&type=style&index=0&id=472653f7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472653f7",
  null
  
)

export default component.exports